import { css } from '@emotion/react';
import MEDIA_QUERY from '../mediaQuery';

export const mobileOnly = css`
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    display: none;
  }
`;

export const tabletOnly = css`
  ${MEDIA_QUERY.EXCLUDE_TABLET} {
    display: none;
  }
`;

export const desktopOnly = css`
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    display: none;
  }
`;

export const excludeMobile = css`
  ${MEDIA_QUERY.MOBILE} {
    display: none;
  }
`;

export const excludeTablet = css`
  ${MEDIA_QUERY.TABLET} {
    display: none;
  }
`;

export const excludeDesktop = css`
  ${MEDIA_QUERY.DESKTOP} {
    display: none;
  }
`;

export const RESPONSIVE_CLASSES = {
  mobileOnly,
  tabletOnly,
  desktopOnly,
  excludeMobile,
  excludeTablet,
  excludeDesktop,
};
